import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ApiService } from 'src/app/core/services/api.service';
import { Point } from '../../models/point';
import { ModelesDocuments } from '../../models/modelesDocuments.model';
import { Meeting } from '../../models/meeting';
import { DetailISignLots, PrepareISignLots } from '../../models/Isign/prepare-isign-lots';
import { TranslateService } from '@devinforius/super-compos-17';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { ConfirmationService } from 'primeng/api';
import { NgxSpinnerService } from 'ngx-spinner';
import { IDelibeGlobalService } from 'src/app/core/services/idelibe/global.service';

@Component({
  selector: 'app-portal-isign',
  templateUrl: './portal-isign.component.html',
  styleUrls: ['./portal-isign.component.scss'],
})
export class PortaliSignComponent implements OnInit {
  modele: ModelesDocuments;
  modelesDocPoint: ModelesDocuments[] = [];
  errorMessage: string[] = [];
  errorCount: number = 0;
  successMessage: string[] = [];
  successCount: number = 0;
  filteredDetailsSuccess: DetailISignLots[] = [];
  constructor(
    public api: ApiService,
    public IDelibeGlobalService: IDelibeGlobalService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public translate: TranslateService,
    public toastr: ToastrService,
    private confirmationService: ConfirmationService,
    public spinner: NgxSpinnerService,
  ) {
  }

  ngOnInit(): void {
    if(this.config.data.point) {
      const pointIds: number[] = this.config.data.point.map((m: Point) => m.id);
      this.IDelibeGlobalService.getGlobalModelesDoc(null, pointIds, null, true, false).subscribe((res: ModelesDocuments[]) => {
        this.modelesDocPoint = res;
        this.setInitialValue([this.config.data?.modeleSelected]);
      });
    } else {
      const meetingIds: number[] = this.config.data.meeting.map((m: Meeting) => m.id);
      this.IDelibeGlobalService.getGlobalModelesDoc(meetingIds, null, null, true, false).subscribe((res: ModelesDocuments[]) => {
        this.modelesDocPoint = res;
        this.setInitialValue(this.config.data?.modeleSelected);
      });
    }
  }

  setInitialValue(modelSelected: ModelesDocuments[]): void {
    if(!modelSelected || !modelSelected[0]) return;
    const selectedModel = this.modelesDocPoint.find(
      model => model.id === modelSelected[0].id && model.description === modelSelected[0].description
    );
    if (selectedModel) {
      this.modele = selectedModel;
      this.onSelectModel(this.modele);
    }
  }

  reinitMessage(): void {
    this.errorCount = 0;
    this.successCount = 0;
    this.errorMessage = [];
    this.successMessage = [];
  }

  onSelectModel(modelesDocuments: ModelesDocuments): void {
    if(!modelesDocuments) return this.reinitMessage();
    this.reinitMessage();
    const data = {
      pointIds: this.config.data.point ? this.config.data.point.map((p: Point) => p.id) : [],
      seanceIds: this.config.data.meeting ? this.config.data.meeting.map((p: Meeting) => p.id) : [],
      modeleIdsUtilises: [modelesDocuments.id]
    };

    if (this.config.data.point) {
      this.api.getPrepareISignLotsSingleSeance(this.config.data.point[0].seanceId, data).subscribe((res: PrepareISignLots) => {
        this.handlePrepareISignLotsResponse(res);
      });
    } else {
      this.api.getPrepareISignLotsMultiSeance(data).subscribe((res: PrepareISignLots) => {
        this.handlePrepareISignLotsResponse(res);
      });
    }
  }

  handlePrepareISignLotsResponse(res: PrepareISignLots): void {
    console.log('res 11 ==>', res);
    const diamondIcon = `<i class="bi bi-exclamation-diamond mr-1"></i>`;
    if(!res) return;
    if (!res.canUseISign) {
      this.errorCount = 1;
      this.errorMessage = [this.translate.translate('error.noRightToSendToISign')];
      return;
    }
    if(res.errorCode) {
      this.errorCount++;
      switch (res.errorCode) {
        case 14350: // File send to iSign or already Signed
          this.errorMessage.push(
            `${diamondIcon} - 
            Fichier déjà envoyé à iSign ou déjà signé`
          );
          break;
        case 14351: // File To Send to iSign not found
          this.errorMessage.push(
            `${diamondIcon} - 
            Pas de fichier pour un modèle`
          );
          break;
        case 14352: // Participants with signature for iSign not found
          this.errorMessage.push(
            `${diamondIcon} - 
            Aucun participant avec une signature trouvé`
          );
          break;
        case 14353: // No signature defined in Signature Maintenance
          this.errorMessage.push(
            `${diamondIcon} - 
            Aucune signature définie dans la maintenance des signatures`
          );
          break;
        case 14355: // iSign Credentials Missing
          this.errorMessage.push(
            `${diamondIcon} - 
            Informations d'identification iSign manquantes`
          );
          break;
        case 14356: // iSign Cant be Used by User
          this.errorMessage.push(
            `${diamondIcon} - 
            iSign ne peut pas être utilisé par l'utilisateur`
          );
          break;
        case 14357: // iSign User without Email
          this.errorMessage.push(
            `${diamondIcon} - 
            Un ou plusieurs utilisateurs n'ont pas d'email`
          );
          break;
        default: // Record Not Found
          this.errorMessage.push(
            `${diamondIcon} - 
            Record not found`
          );
          break;
      }
      return;
    }
    this.generateMessageStatus(res);
  }

  verifyBeforeGenerate(): void {
    if (!environment.production) {
      this.confirmationService.confirm({
        message: 'Vous êtes dans un environnement de '+ '<b>DEV</b>' + '. Si vous continuer, les messages de signature vont être envoyé aux clients. Voulez vous continuer ?',
        key: 'confirmIfDev',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Confirmer',
        acceptButtonStyleClass: 'p-button-danger',
        rejectLabel: 'Annuler',
        defaultFocus: 'reject',
        accept: () => {
          this.generate();
        },
        reject: () => {
          console.info('Action annulée');
        }
      });
    } else {
      this.generate();
    }
  }

  generate(): void {
    this.spinner.show();
    const data = {
      pointIds: this.config.data.point ? this.config.data.point.map((p: Point) => p.id) : [],
      seanceIds: this.config.data.meeting ? this.config.data.meeting.map((p: Meeting) => p.id) : [],
      modeleIdsUtilises: this.filteredDetailsSuccess.map((p: DetailISignLots) => p.modeleDocumentId)
    };
    if (this.config.data.point) {
      this.api.sendDocPointToIsign(this.config.data.point[0].seanceId, data).subscribe({
        next: () => {
          this.spinner.hide();
          this.toastr.success(this.translate.translate('Les ' + this.successCount + ' ' + this.translate.translate('success.documentSendToISign')));
          this.ref.close('generate');
        },
        error: (err: Error) => {
          console.error('err ==>', err);
          this.spinner.hide();
          this.toastr.error(this.translate.translate('error.errorSendToISign'));
          this.ref.close();
        }
      });
    } else {
      this.api.sendDocMeetingToIsign(data).subscribe({
        next: () => {
          this.spinner.hide();
          this.toastr.success(this.translate.translate('Les ' + this.successCount + ' ' + this.translate.translate('success.documentSendToISign')));
          this.ref.close('generate');
        },
        error: (err: Error) => {
          console.error('err ==>', err);
          this.spinner.hide();
          this.toastr.error(this.translate.translate('error.errorSendToISign'));
          this.ref.close();
        }
      });
    }
  }

  // ! Je laisse cette fonction en commentaire elle sert a générer les messages 
  // ! d'erreur et de succès dans le cas ou la selection des modeles de documents est multiple 
  // ! Vu qu'on sais que dans 2 mois, on nous demandera de le remettre en place.
  // generateMessageStatusOld(res: PrepareISignLots): void {
  //   const typeSelected = this.config.data.point ? 'pointId' : 'seanceId';
  //   const filteredDetailsError = res.details.filter(detail => !detail.canUseISign);
  //   this.errorCount = filteredDetailsError.length;
  //   this.filteredDetailsSuccess = res.details.filter(detail => detail.canUseISign);
  //   this.successCount = this.filteredDetailsSuccess.length;
  //   if(filteredDetailsError.length > 0) {
  //     const groupById = _.groupBy(filteredDetailsError, typeSelected);
  //     const idSelectedError: string[] = Object.keys(groupById);
  //     idSelectedError.forEach((id: string) => {
  //       const idModel = groupById[id].map((detail: DetailISignLots) => detail.modeleDocumentId);
  //       const details = groupById[id];
        
  //       details.forEach((detail: DetailISignLots) => {
  //         if(detail.errorCode && !detail.canUseISign) {
  //           switch(detail.errorCode) {
  //             case 14351: // File To Send to iSign not found
  //               this.errorMessage.push(`<i class="bi bi-exclamation-diamond-fill mr-1"></i> - Erreur pour ${typeSelected === 'pointId' ? 'le point' : 'la séance'} ${id} => Pas de fichier pour le(s) modèle(s) : ${idModel.join(', ')}`);
  //               break;
  //             case 14352: // Participants with signature for iSign not found
  //               this.errorMessage.push(`<i class="bi bi-exclamation-diamond-fill mr-1"></i> - Aucun participant avec une signature trouvé pour ${typeSelected === 'pointId' ? 'le point' : 'la séance'} ${id}`);
  //               break;
  //             case 14353: // No signature defined in Signature Maintenance
  //               this.errorMessage.push(`<i class="bi bi-exclamation-diamond-fill mr-1"></i> - Aucune signature définie dans la maintenance des signatures pour ${typeSelected === 'pointId' ? 'le point' : 'la séance'} ${id}`);
  //               break;
  //             default: // Record Not Found
  //               this.errorMessage.push(`<i class="bi bi-exclamation-diamond-fill mr-1"></i> - Record not found => ${detail.errorText}`);
  //               break;
  //           }
  //         } else if(!detail.errorCode && !detail.canUseISign) {
  //           const status = detail.iSignStatus === 1 ? 'Signature en cours' : detail.iSignStatus === 2 ? 'Signé' : detail.iSignStatus === 3 ? 'Signature refusée' : 'Erreur de signature';
  //           this.errorMessage.push(`<i class="bi bi-exclamation-diamond-fill mr-1"></i> - Le document ${detail.modeleDocumentId} pour ${typeSelected === 'pointId' ? 'le point' : 'la séance'} ${id} est déjà en cours de traitement => ${status}`);
  //         }
  //       });
  //       const uniqueArray = Array.from(new Set(this.errorMessage));
  //       this.errorMessage = uniqueArray;
  //     });
  //   }
  //   if(this.filteredDetailsSuccess.length > 0) {
  //     const groupById = _.groupBy(this.filteredDetailsSuccess, typeSelected);
  //     const idSelectedSucces: string[] = Object.keys(groupById);

  //     idSelectedSucces.forEach((id: string) => {
  //       const idModel = groupById[id].map((detail: DetailISignLots) => detail.modeleDocumentId);
  //       const details = groupById[id];
  //       this.successMessage.push(`<i class="bi bi-check-circle-fill"></i> - Le(s) modèle(s) <b>${idModel.join(', ')}</b> ${details[0].type === 1 ? 'du point' : 'de la séance'} ${id} va/vont être envoyé(s) en signature`);
  //     });
  //   }
  // }

  generateMessageStatus(res: PrepareISignLots): void {
    console.log('res ==>', res);
    const typeSelected = this.config.data.point ? 'pointId' : 'seanceId';
    const filteredDetailsError = res.details.filter(detail => !detail.canUseISign);
    this.errorCount = filteredDetailsError.length;
    this.filteredDetailsSuccess = res.details.filter(detail => detail.canUseISign);
    this.successCount = this.filteredDetailsSuccess.length;
console.log('filteredDetailsError ==>', filteredDetailsError);
    if(filteredDetailsError.length > 0) {
      const groupById = _.groupBy(filteredDetailsError, 'errorCode');
      const idSelectedError: string[] = Object.keys(groupById);
      const pointIds = groupById[idSelectedError[0]].map((detail: DetailISignLots) => detail.pointId);
      const meetingIds = groupById[idSelectedError[0]].map((detail: DetailISignLots) => detail.seanceId);
      const diamondIcon: string = `<i class="bi bi-exclamation-diamond-fill mr-1"></i>`;
      let ordreDocs: number[] = [];
      if(typeSelected === 'pointId') {
        ordreDocs = this.config.data.point
        .filter((point: Point) => pointIds.includes(+point.id))
        .map((point: Point) => point.ordreDocs);
      }
      idSelectedError.forEach((id: string) => {
        const listIdsError: string = `${typeSelected === 'pointId' ? 
          (ordreDocs.length > 1 ? 'les points' : 'le point') 
          : (meetingIds.length > 1 ? 'les séances' : 'la séance')} 
        ${typeSelected === 'pointId' ? ordreDocs.join(', ') : meetingIds.join(',')} `;
          
        groupById[id].forEach((detail: DetailISignLots) => {
          if(detail.errorCode && !detail.canUseISign) {

            switch (detail.errorCode) {
              case 14350: // File send to iSign or already Signed
                this.errorMessage.push(
                  `${diamondIcon} - 
                  Erreur pour ${listIdsError} 
                  <br>=> Fichier déjà envoyé à iSign ou déjà signé`
                );
                break;
              case 14351: // File To Send to iSign not found
                this.errorMessage.push(
                  `${diamondIcon} - 
                  Erreur pour ${listIdsError} 
                  <br>=> Pas de fichier pour le modèle`
                );
                break;
              case 14352: // Participants with signature for iSign not found
                this.errorMessage.push(
                  `${diamondIcon} - 
                  Aucun participant avec une signature trouvé pour ${listIdsError}`
                );
                break;
              case 14353: // No signature defined in Signature Maintenance
                this.errorMessage.push(
                  `${diamondIcon} - 
                  Aucune signature définie dans la maintenance des signatures pour ${listIdsError}`
                );
                break;
              case 14355: // iSign Credentials Missing
                this.errorMessage.push(
                  `${diamondIcon} - 
                  Informations d'identification iSign manquantes pour ${listIdsError}`
                );
                break;
              case 14356: // iSign Cant be Used by User
                this.errorMessage.push(
                  `${diamondIcon} - 
                  iSign ne peut pas être utilisé par l'utilisateur pour ${listIdsError}`
                );
                break;
              case 14357: // iSign User without Email
                this.errorMessage.push(
                  `${diamondIcon} - 
                  Un ou plusieurs utilisateurs n'ont pas d'email`
                );
                break;
              default: // Record Not Found
                this.errorMessage.push(
                  `${diamondIcon} - 
                  Record not found => ${detail.errorText}`
                );
                break;
            }
          } else if (!detail.errorCode && !detail.canUseISign) {
            const status = detail.iSignStatus === 1 ? 'Signature en cours' : detail.iSignStatus === 2 ? 'Signé' : detail.iSignStatus === 3 ? 'Signature refusée' : 'Erreur de signature';
            this.errorMessage.push(
              `${diamondIcon} - 
              ${listIdsError} 
              est déjà en cours de traitement <br>=> ${status}`
            );
          }
        });
      });
      const uniqueArray = Array.from(new Set(this.errorMessage));
      this.errorMessage = uniqueArray;
    }
    if(this.filteredDetailsSuccess.length > 0) {
      const pointIds = this.filteredDetailsSuccess.map((detail: DetailISignLots) => detail.pointId);
      const meetingIds = this.filteredDetailsSuccess.map((detail: DetailISignLots) => detail.seanceId);
      let ordreDocs: number[] = [];
      if(typeSelected === 'pointId') {
        ordreDocs = this.config.data.point
        .filter((point: Point) => pointIds.includes(+point.id))
        .map((point: Point) => point.ordreDocs);
      }
      this.successMessage.push(
        `<i class="bi bi-check-circle-fill"></i> - 
        ${typeSelected === 'pointId' ? 
          (ordreDocs.length > 1 ? 'Les points' : 'Le point') 
          : (meetingIds.length > 1 ? 'Les séances' : 'La séance')} 
        ${typeSelected === 'pointId' ? ordreDocs.join(', ') : meetingIds.join(',')} 
        ${typeSelected === 'pointId' ? 
          (ordreDocs.length > 1 ? 'vont être envoyés' : 'va être envoyé') 
          : (meetingIds.length > 1 ? 'vont être envoyées' : 'va être envoyée')} 
        en signature`
      );
      const uniqueArray = Array.from(new Set(this.successMessage));
      this.successMessage = uniqueArray;
    }
  }
}